export const scrollChat = () => {
    let chat = document.getElementById("mensajesChatMensajes")
    let scroll = chat.scrollHeight+10000
    chat.scrollTop = scroll
}
